import { BulbOutlined, WalletOutlined } from '@ant-design/icons'

const searchHierarchyTree = (treenode, id) => {
  if (treenode?.eliasID === id) {

    return treenode
  } else if (treenode?.children !== null) {
    let result = null

    for (let i = 0; result === null && i < treenode?.children?.length; i++) {
      result = searchHierarchyTree(treenode?.children[i], id)
    }

    return result
  }

  return null
}

 const getKnownAsFromHierarchy = id => {
  const hierarchy = window.hierarchy || []

  for (const h of hierarchy) {
    var result = searchHierarchyTree(h, id)

    if (result) {
      return result
    }
  }

  return null
}

export const getCopyListOptions = assetList => {
  const options = assetList.map((a) => {
    const eliasId = a.assetType.eliasID
    const knownAs = getKnownAsFromHierarchy(eliasId)?.knownAs || undefined
    
    return ({
      value: a.id,
      label: (
        <>
          {a.assetType?.virtual === true ? (
            <BulbOutlined />
          ) : (
            <WalletOutlined />
          )}{' '}
          {knownAs ? `${knownAs}` : `${a.assetType?.description}`}
        </>
      ),
      description: a.notes?.description,
    })
  })

  return options
}
